import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserProfileLocation } from "../../../@types/userProfileLocation";

import api from "../../../utils/api";

// Busqueda de Locations
export const findProfileLocations = createAsyncThunk(
    "userProfileLocation/findProfileLocations",
    async ({ userId, profileId }: { userId: string | undefined, profileId: string | undefined }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            const headers = new Headers();
            headers.append("Authorization", `Bearer ${token}`);
            headers.append("Content-Type", "application/json");
      
            const result = await fetch(`${api.baseURL}userprofilelocation?where={"user":"${userId}","profile":"${profileId}"}&limit=10000`,{
                method: "GET",
                headers: headers,
            });
            const data = await result.json();
            return data as UserProfileLocation[];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);